/* eslint-disable import/no-anonymous-default-export */
export default {
  motd: "Welcome to DP7 Charmless Server!"
};
